import React from "react";
import { Link } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import * as UserActions from "../../redux/actions/user.actions";
import "./Login.css";

const EyeOpen = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/>
    <circle cx="12" cy="12" r="3"/>
  </svg>
);

const EyeClosed = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24"/>
    <line x1="1" y1="1" x2="23" y2="23"/>
  </svg>
);

const Login = () => {
  const { defConfig, defLang, usertoken } = useSelector((state) => state.Login);
  const dispatch = useDispatch();

  const [showDomain, setShowDomain] = React.useState(true);
  const [showPassword, setShowPassword] = React.useState(false);
  const [values, setValues] = React.useState({
    domain:   process.env.REACT_APP_DEF_ORG  || "",
    email:    process.env.REACT_APP_DEF_USER || "",
    password: process.env.REACT_APP_DEF_PSS  || "",
  });

  React.useEffect(() => {
    if (usertoken) {
      // Hard navigation (no SPA soft nav): fuerza recarga completa de la ventana
      // para limpiar estado residual (Redux store, variables module-level) de
      // una sesión anterior si se hizo logout/login en la misma pestaña sin refrescar.
      window.location.assign("/dashboard");
      return;
    }
     
  }, [usertoken]);

  const onChange = (e) => {
    const { name, value } = e.target;
    setValues((v) => ({ ...v, [name]: value }));
  };

  const submitForm = (e) => {
    e.preventDefault();
    dispatch(UserActions.login(values));
  };

  const lbl = defConfig[defLang] || {};

  return (
    <div className="xflow-login-page">
      <div className="xflow-login-main">

        {/* ── Left panel (dark) ── */}
        <div className="xflow-login-panel">
          <div className="xflow-login-logo-wrap">
            <img
              src={process.env.REACT_APP_CUSTOM_LOGO_IMAGE || "/images/logo.png"}
              onError={(e) => { e.currentTarget.src = "/images/logo.png"; }}
              alt={process.env.REACT_APP_COMPANY || "xFlow"}
              className="xflow-login-logo"
            />
          </div>
          <div className="xflow-login-brand">
            <span className="xflow-kicker">xFlow Workspace</span>
            <h2>Flujos y tareas<br/>en un solo lugar</h2>
            <p>Seguimiento claro para equipos que necesitan avanzar rápido.</p>
          </div>
        </div>

        {/* ── Right panel (form) ── */}
        <div className="xflow-login-form-panel">
          {/* Logo visible solo en mobile */}
          <div className="xflow-login-mobile-logo">
            <img
              src={process.env.REACT_APP_CUSTOM_LOGO_IMAGE || "/images/logo.png"}
              onError={(e) => { e.currentTarget.src = "/images/logo.png"; }}
              alt={process.env.REACT_APP_COMPANY || "xFlow"}
            />
          </div>

          <div className="xflow-login-card">
            <div className="xflow-login-title">
              <span className="xflow-kicker">xFlow Workspace</span>
              <h1>{lbl.signin || "Sign in"}</h1>
            </div>

            <form onSubmit={submitForm} autoComplete="on">

              {showDomain && (
                <div className="xfl-field">
                  <label htmlFor="lf-domain">{lbl.formorganization || "Organization"}</label>
                  <input
                    id="lf-domain"
                    name="domain"
                    type="text"
                    autoComplete="organization"
                    placeholder="Enter organization"
                    value={values.domain}
                    onChange={onChange}
                    required
                  />
                </div>
              )}

              <div className="xfl-field">
                <label htmlFor="lf-email">{lbl.formemail || "Email"}</label>
                <input
                  id="lf-email"
                  name="email"
                  type="email"
                  autoComplete="username"
                  placeholder="Enter email"
                  value={values.email}
                  onChange={onChange}
                  required
                />
              </div>

              <div className="xfl-field">
                <label htmlFor="lf-password">{lbl.formpassword || "Password"}</label>
                <div className="xfl-password-wrap">
                  <input
                    id="lf-password"
                    name="password"
                    type={showPassword ? "text" : "password"}
                    autoComplete="current-password"
                    placeholder="Enter your password"
                    value={values.password}
                    onChange={onChange}
                    required
                  />
                  <button
                    type="button"
                    className="xfl-eye-btn"
                    onClick={() => setShowPassword((v) => !v)}
                    aria-label={showPassword ? "Ocultar contraseña" : "Mostrar contraseña"}
                    tabIndex={-1}
                  >
                    {showPassword ? <EyeClosed /> : <EyeOpen />}
                  </button>
                </div>
              </div>

              <div className="xfl-forgot">
                <Link to="/forgot-password">{lbl.forgotpassword || "¿Olvidaste tu contraseña?"}</Link>
              </div>

              <button type="submit" className="e-btn e-primary xflow-login-submit">
                {lbl.signin || "Ingresar"}
              </button>
            </form>
          </div>
        </div>
      </div>

      <div className="xflow-login-copyright text-center">
        © 2023–2026 <b> xFlow PRO versión 2</b>
      </div>
    </div>
  );
};

export default Login;
